import { useState, useEffect, Dispatch } from 'react';

export function useHistoryState<T>(initialState: T, key: string): [T, Dispatch<T>] {
   const [state, setState] = useState(window.history.state?.[key] ?? initialState);

   useEffect(() => {
      window.history.replaceState({ ...window.history.state, [key]: state }, '');
      return () => {
         const history = window.history.state;
         if (history?.[key]) {
            delete history.key;
         }
         window.history.replaceState(history, '');
      };
   }, [state, key]);

   return [state, setState];
}
